import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { TransactionService } from 'src/app/services/transaction.service';

@Injectable()
export class PaymentGuideResolver implements Resolve<any> {
  constructor(private transactionService: TransactionService) {}

  public resolve(route: ActivatedRouteSnapshot) {
    const transactionID = route.params.id;
    return this.transactionService
      .getPaymentGuideGt(transactionID)
      .toPromise()
      .then((result: any) => {
        return result.data || null;
      })
      .catch(error => {
        return null;
      });
  }
}
